<i18n src="./translations"></i18n>

<template>
  <div
    v-if="pairedArticle"
    class="paired-article-banner"
    data-testid="paired-article-banner"
  >
    <Icon
      name="paired_articles"
      class="paired-article-banner__icon"
      width="24"
      height="24"
      aria-hidden="true"
    />
    <p class="paired-article-banner__text">
      {{ $t('paired-article-banner.label') }}:
      <a
        class="paired-article-banner__link"
        :href="pairedArticle.link"
        data-testid="paired-article-banner-link"
        data-ssel-click="related_article"
        :data-ssel-label="pairedArticle.articleNumber"
        :data-ssel-context="sselContext"
        >{{ pairedArticle.articleNumber }}</a
      >
    </p>
  </div>
</template>

<script>
import Icon from 'Components/00-generated/Icon.vue';
import {
  getPairedArticle,
  PAIRED_ARTICLE_NUMBERS_ID,
} from 'Libs/helpers/attribute-catalog-search';

export default {
  name: 'PairedArticleBanner',
  components: {
    Icon,
  },
  props: {
    attributes: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    pairedArticle() {
      return getPairedArticle(this.attributes);
    },
    sselContext() {
      return JSON.stringify({
        relationship_type: PAIRED_ARTICLE_NUMBERS_ID,
        target_article_number: this.pairedArticle.articleNumber,
        resolution: 'resolved',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.paired-article-banner {
  display: flex;
  align-items: center;
  gap: var(--space-1);
  padding: var(--space-1);
  border-radius: 3px;
  background-color: var(--color-silver-fog);
  color: var(--color-nero);

  &__icon {
    flex-shrink: 0;
  }

  &__text {
    flex: 1;
    margin: 0;
    min-width: 0;
    font-size: var(--font-size-M);
    line-height: 18px;
    word-break: break-word;
  }

  &__link {
    color: inherit;
    text-decoration: underline;
  }
}
</style>
